var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTwitterWhite = function SvgTwitterWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.543 4.995c.015.216.015.433.015.652 0 6.673-4.953 14.368-14.01 14.368v-.004A13.688 13.688 0 0 1 0 17.748a9.731 9.731 0 0 0 7.287-2.093c-2.107-.041-3.954-1.45-4.6-3.507a4.79 4.79 0 0 0 2.223-.087C2.613 11.585.96 9.515.96 7.111v-.064a4.8 4.8 0 0 0 2.235.632C1.032 6.196.365 3.245 1.671.937c2.5 3.155 6.189 5.072 10.148 5.275a5.136 5.136 0 0 1 1.425-4.824 4.843 4.843 0 0 1 6.966.219A9.732 9.732 0 0 0 23.337.38a5.049 5.049 0 0 1-2.165 2.793A9.603 9.603 0 0 0 24 2.379a10.15 10.15 0 0 1-2.457 2.616Z",
    fill: "currentColor"
  })));
};
export default SvgTwitterWhite;